import { orderBy, toLower } from 'lodash';
const byKey = function () {
  let option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let sortKey = arguments.length > 1 ? arguments[1] : undefined;
  return toLower(option[sortKey]);
};
const sortByKey = _ref => {
  let {
    options = [],
    sortKey = 'label',
    sortDirection = 'asc'
  } = _ref;
  return orderBy(options, option => byKey(option, sortKey), sortDirection);
};
export default sortByKey;
//# sourceMappingURL=sortByKey.js.map